import React from 'react'

import NotificationLogsListing from './NotificationLogsListing'

// Detail is presented in a right-side drawer over the list, so there is no
// separate detail route.
const NotificationLogs = () => <NotificationLogsListing />

export default NotificationLogs
